import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { SaleInvoiceSendByEmailPage } from './sale-invoice-send-by-email.page';
import {ActionDefaultPagePageModule} from '../../../../../../core/page/action-default-page/action-default-page.module';
import {ViewByIdDefaultModule} from '../../../../../../core/component/view-by-id-default/view-by-id-default.module';
import {ViewByAttributeModule} from '../../../../../../core/component/view-by-attribute/view-by-attribute.module';
import {CardModule} from '../../../../../../core/component/card/card.module';
import {
  EmailContentFormModule
} from '../../../../../../communication/email/api/component/email-content-form/email-content-form.module';
import {
    SaleInvoiceDetailsCardModule
} from '../../../api/component/sale-invoice-details-card/sale-invoice-details-card.module';
import {DialogModule} from '../../../../../../common/dialog/dialog.module';
import {ActionDefaultModule} from '../../../../../../core/component/action-default/action-default.module';
import {
    SendEmailTriggerFormComponent
} from "../../../../../../communication/email/api/component/send-email-trigger-form/send-email-trigger-form.component";
import {ActionButtonModule} from "../../../../../../core/component/action-button/action-button.module";
import {CardV2Component} from "../../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ActionDefaultPagePageModule,
        ViewByIdDefaultModule,
        ViewByAttributeModule,
        CardModule,
        EmailContentFormModule,
        SaleInvoiceDetailsCardModule,
        DialogModule,
        ActionDefaultModule,
        SendEmailTriggerFormComponent,
        ActionButtonModule,
        CardV2Component
    ],
  declarations: [SaleInvoiceSendByEmailPage]
})
export class SaleInvoiceSendByEmailPageModule {}
